export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_NUMBER_OF_PAGES_TO_SHOW = 5;
export const LIMIT = 10;
